(function (Drupal) {

  Drupal.behaviors.alumniStoriesFilters = {
    attach(context) {
      if (window.multipleSelect !== undefined) {
        const selects = document.querySelectorAll('select.custom-select[multiple]');
        const facets = context.querySelectorAll('ul li.facet-item');

        selects.forEach((select) => {
          multipleSelect(select, {
            selectAll: false,
            width: '100%',
            filter: true,
            displayTitle: true,
            renderOptionLabelAsHtml: true,
            onAfterCreate: () => updatePlaceholder(select),
            onCheckAll: () => updatePlaceholder(select),
            onUncheckAll: () => updatePlaceholder(select),
            onOptgroupClick: () => updatePlaceholder(select),
            onClick: (view) => {
              updateUrl(select, view.value);
              updatePlaceholder(select);
            },
            onClose: () => {
              callback_onSelect(select);
            },
          });
        });

        multipleSelect('select.custom-select:not([multiple])', {
          selectAll: false,
          width: '100%',
          filter: true,
          displayTitle: true,
          renderOptionLabelAsHtml: true,
        });

        context.querySelectorAll('select.form-select + div').forEach(element => {
          element.classList.remove('form-select');
        });
      }

      function callback_onSelect(select) {
        let collection = select.selectedOptions;
        const values = [...collection].map((option) => {
          return option.label;
        });
      }

      function updateUrl(select, value) {
        if (value !== '') {
          window.location.href = value;
          let parent = select.parentNode;
          parent.querySelector('.ms-parent-open').classList.remove('ms-parent-open');
          parent.querySelector('.ms-drop').classList.add('d-none');
        }
      }

      function updatePlaceholder(select) {
        const placeholder = select.getAttribute('data-placeholder');
        const selectedOptions = select.selectedOptions;
        const selectedCount = selectedOptions.length;

        const placeholderSpan = select.nextElementSibling.querySelector('.ms-choice span');
        if (selectedCount > 0) {
          placeholderSpan.innerHTML = `${placeholder} <span class="count">${selectedCount}</span>`;
        }
        else {
          placeholderSpan.textContent = placeholder;
        }
      }
    },
  };
})(Drupal);
